import { render, staticRenderFns } from "./NavMenus.vue?vue&type=template&id=0645f4a0&scoped=true"
import script from "./NavMenus.vue?vue&type=script&lang=js"
export * from "./NavMenus.vue?vue&type=script&lang=js"
import style0 from "./NavMenus.vue?vue&type=style&index=0&id=0645f4a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0645f4a0",
  null
  
)

export default component.exports